import React, { forwardRef, useEffect } from 'react';
import { formatPriceWithEuro } from '../../../utils/StringUtils';

const PaygreenBankCardForm = (
  {
    handleSaveCard,
    errorMessage,
    loading,
    cardNbComplete,
    cardExpComplete,
    cardCVCComplete,
    cartItems,
    onInitPaygreenEventListeners,
    initPaygreen,
    paymentEventTriggered,
    conecs,
    handleSubmit,
    save,
    showPaymentFields,
    paymentInputLoading,
  },
  ref,
) => {
  const paygreen_endpoint = process.env.REACT_APP_PAYGREEN_API_ENDPOINT;

  useEffect(() => {
    const script = document.createElement('script');
    script.src = paygreen_endpoint;
    script.async = true;
    script.onload = () => {
      onInitPaygreenEventListeners();
      if (!conecs || !conecs.buyerId) {
        initPaygreen();
      }
    };
    document.body.appendChild(script);
    return () => {
      paymentEventTriggered = false;
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <div id="paygreen-container" style={{ display: 'none' }} />
      <div id="paygreen-methods-container" style={{ visibility: 'hidden' }} />

      {/*{paymentInputLoading && <CustomLoader/>}*/}
      {showPaymentFields && (
        <div className="paygreen-form">
          <div className="child1">
            <div className="mt-2" id="paygreen-pan-frame">
              {/*<img id="pan-check" className="absolute right-0 bottom-0 h-6 invisible"*/}
              {/*     src="/images/check-2.svg" />*/}
            </div>
          </div>
          <div className="date-and-crypto-container">
            <div className="child2">
              <div className="mt-2" id="paygreen-exp-frame">
                {/*<img*/}
                {/*  id="exp-check"*/}
                {/*  className="absolute right-0 bottom-0 h-6 invisible"*/}
                {/*  src="/images/check-2.svg"*/}
                {/*/>*/}
              </div>
            </div>
            <div className="paygreen-cvv-container child3 ">
              <div className="mt-2" id="paygreen-cvv-frame"></div>
              <img
                id="cvv-check"
                className="absolute right-0 bottom-0 h-6 invisible"
                src="/images/check-2.svg"
              />
              <i data-feather="help-circle"></i>
              <img
                id="cvv-check"
                className="absolute right-0 bottom-0 h-6 invisible"
                src="/images/check-2.svg"
              />
              <i data-feather="help-circle"></i>
            </div>
          </div>
        </div>
      )}

      <div id="enregistrer" className={' flex items-center w-full ml-6'}>
        <input
          className="w-[0px] "
          id="paygreenCheckboxenregistrer"
          type="checkbox"
          checked={save}
          onChange={handleSaveCard}
        />
        <label
          htmlFor="paygreenCheckboxenregistrer"
          className="paygreenlabelenregistrer"
        ></label>
        <label
          htmlFor="paygreenCheckboxenregistrer"
          className="flex items-center ml-6"
        >
          <h3
            className=" text-[ tracking-tighter] text-[1.4rem]"
            style={{ color: '#5A5A5A', fontWeight: 400 }}
          >
            Enregistrer pour la prochaine fois
          </h3>
        </label>
      </div>
      <div className="payment-error full no-bottom">{errorMessage}</div>
      <div className={'flex flex-col w-full'}>
        {/*<button*/}
        {/*  className={`payer_maintenant_btn flex items-center ${*/}
        {/*    !cardCVCComplete || !cardExpComplete || !cardNbComplete*/}
        {/*      ? 'pointer-events-none opacity-20'*/}
        {/*      : ''*/}
        {/*  }`}*/}
        {/*  onClick={handleSubmit}*/}
        {/*  disabled={test()}*/}
        {/*>*/}
        <button
          className={'payer_maintenant_btn flex items-center'}
          // onClick={handleSubmit}
        >
          {loading ? (
            <>
              <p>Chargement...</p>
            </>
          ) : (
            <>
              <p
                className="font-light"
                style={{ fontFamily: 'geomanistmedium' }}
              >
                Payer maintenant
              </p>
            </>
          )}
        </button>
      </div>
    </>
  );
};
export default forwardRef(PaygreenBankCardForm);
